var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mySubPage',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('myNav',[_vm._v("信誉值流动历史["+_vm._s(_vm.vendor_cname)+"]")])],1),_vm._v(" "),_c('div',{staticClass:"relative fillh"},[(_vm.vendor_id != '')?_c('myVendorCrSn',{attrs:{"vendor_id":_vm.vendor_id}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b6da10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vendor/code/crsn.vue
// module id = null
// module chunks = 